import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioBillingCsv, portfolioBillingCsvURL, } from "../request/getPortfolioBillingCsv";
export function portfolioBillingCsvKeyMaker(queryParams) {
    if (!queryParams) {
        throw new Error("versionId is required for portfolio billing CSV");
    }
    return [portfolioBillingCsvURL(queryParams)];
}
const useGetPortfolioBillingCsv = makeHook(getPortfolioBillingCsv, portfolioBillingCsvKeyMaker);
export default useGetPortfolioBillingCsv;
//# sourceMappingURL=useGetPortfolioBillingCsv.js.map